import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import FloatingCTAs from "./FloatingCTAs";
import { useSite } from "../../context/SiteContext";

const TITLES = {
  "/loans": "Loan Products – Personal, Home, Business & More | BharatBest Fintech",
  "/calculators": "Financial Calculators – EMI, Eligibility & Comparison | BharatBest Fintech",
  "/calculators/emi": "EMI Calculator – Estimate Your Monthly Payment | BharatBest Fintech",
  "/calculators/eligibility": "Loan Eligibility Checker – Indicative Estimate | BharatBest Fintech",
  "/eligibility": "Loan Eligibility Checker – Indicative Estimate | BharatBest Fintech",
  "/compare-loans": "Compare Loans – Rates, Fees & Tenure | BharatBest Fintech",
  "/about": "About Us | BharatBest Fintech",
  "/blog": "Financial Education Blog | BharatBest Fintech",
  "/contact": "Contact Us | BharatBest Fintech",
  "/apply": "Apply for a Loan | BharatBest Fintech",
};

export default function SiteLayout() {
  const { settings } = useSite();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const title = TITLES[location.pathname] || settings?.seo?.title || "BharatBest Fintech";
    document.title = title;
  }, [location.pathname, settings]);

  return (
    <div className="min-h-screen flex flex-col bg-brand-cream">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingCTAs />
    </div>
  );
}
